import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-c01-item-info" }
const _hoisted_2 = { class: "p-the-c01-item-info__name" }
const _hoisted_3 = { class: "p-the-c01-item-info__id" }
const _hoisted_4 = { class: "p-the-c01-item-info__point" }
const _hoisted_5 = {
  key: 1,
  class: "p-the-c01-item-info__stock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_PointNotation = _resolveComponent("PointNotation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status)
      ? (_openBlock(), _createBlock(_component_TextLabel, {
          key: 0,
          color: { border: _ctx.colorCode, content: '#fff' },
          reverse: true,
          class: "p-the-c01-item-info__status"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.status), 1)
          ]),
          _: 1
        }, 8, ["color"]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _createElementVNode("p", _hoisted_3, "商品NO." + _toDisplayString(_ctx.id), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_PointNotation, {
        point: _ctx.point,
        "point-color": _ctx.colorCode,
        "sign-is-exists": false
      }, null, 8, ["point", "point-color"])
    ]),
    (_ctx.isQuantityControl && !_ctx.isBenepoExchange)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 在庫数 : " + _toDisplayString(_ctx.stockText), 1))
      : _createCommentVNode("", true)
  ]))
}